import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from './useStore'
import { getVideoDetails } from '../actions/contentActions'
import { ComcastErrorType, generateErrorData } from '../../../shared/helpers'
import { useLocation } from 'react-router'

export function useVideoDetails(url: string) {
  const dispatch = useAppDispatch()
  const content = useAppSelector((state) => state.content)
  const [error, setError] = useState<Error | null>(null)
  const location = useLocation()

  const handleError = (error: Error) => {
    const errorObj = generateErrorData(error)
    dispatch({
      type: 'TRIGGER_ERROR',
      payload: {
        error: {
          ...errorObj,
          content: {
            errorPath: location.pathname,
          },
          codeBaseLocation: 'useVideoDetails',
          errorType: ComcastErrorType.network,
        },
      },
    })
    setError(error)
    throw error
  }

  const fetchVideoDetails = async (videoUrl: string) => {
    setError(null)
    try {
      const newVideoDetails = await getVideoDetails(videoUrl)
      if (newVideoDetails.expired) {
        const error = new Error('Video expired')
        handleError(error)
      } else if (!newVideoDetails.url) {
        const error = new Error('No video URL')
        handleError(error)
      } else {
        dispatch({
          type: 'SET_VIDEO_DATA',
          payload: { id: url, videoDetails: newVideoDetails },
        })
      }
    } catch (err) {
      const error =
        err instanceof Error ? err : new Error('Failed to fetch video details')
      setError(error)
      throw error
    }
  }

  useEffect(() => {
    if (url && content.id !== url) {
      dispatch({ type: 'RESET_VIDEO_DATA' })
      fetchVideoDetails(url)
    }
  }, [url, content.id])

  return {
    videoDetails: content.videoDetails.url ? content.videoDetails : null,
    error,
  }
}
